export const toCamelCase = (text) => {
  const camelCaseText = text
    .replace(/[^a-zA-Z0-9]+(.)/g, (_match, chr) => chr.toUpperCase())
    .replace(/^[^a-zA-Z0-9]+/, '')
    .replace(/^(.)/, (_match, chr) => chr.toLowerCase());

  return camelCaseText;
};
